/**
 * @class
 */
import Base from './attribute_text';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Textarea extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.textarea,
		};
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @param {object} opts Options
	 * @return {mixed} Formatted value
	 */
	format(value, opts) {
		opts = opts || {};
		value = super.format(value, opts);

		return opts.html !== false ? value && value.replace(/\n/g, '<br>') : value;
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Textarea';
	}
}
